jQuery( document ).ready( function ( $ ) {
	if( $(".block-mp-industries" ).length ) {
	
	}
})